import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {
  ApiResponse,
  PaginablePayloadApiResponse,
} from '@portal-workspace/grow-shared-library';
import { httpOptions } from '@portal-workspace/grow-ui-library';
import { Observable } from 'rxjs';

export interface TransactionReconciliationSync {
  id: number;
  date: string;
  fileName: string | null;
  status: 'Successful' | 'Failed' | 'Not Found' | 'Not Synced';
  error: string | null;
  timestamp: string | null;
}

const URL_GET_RECONCILIATION_SYNC = (limit: number, offset: number, startDate?: string, endDate?: string) => `${environment.api2Host}/api2/reconciliation-sync/${limit}/${offset}/${startDate}/${endDate}`;
const URL_TRIGGER_RECONCILIATION_SYNC = (date: string) => `${environment.api2Host}/api2/fetchDailyReconciliationReport/${date}`;
const URL_DOWNLOAD_RECONCILIATION_FILE = (date: string) => `${environment.api2Host}/api2/reconciliation-download/${date}`;

@Injectable()
export class ReconciliationSyncService {

  constructor(private httpClient: HttpClient) {
  }

  getReconciliationSyncRecords(
    limit: number,
    offset: number,
    startDate: string,
    endDate: string
  ): Observable<PaginablePayloadApiResponse<TransactionReconciliationSync>> {

    return this.httpClient.get<PaginablePayloadApiResponse<TransactionReconciliationSync>>(
      URL_GET_RECONCILIATION_SYNC(limit, offset, startDate, endDate), 
      httpOptions()
    );
  }

  triggerReconciliationSync(date: string): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_TRIGGER_RECONCILIATION_SYNC(date), httpOptions());
  }

  downloadReconciliationFile(date: string): Observable<Blob> {
    return this.httpClient.get<Blob>(URL_DOWNLOAD_RECONCILIATION_FILE(date), {...httpOptions(), responseType: 'blob' as 'json'});
  }
} 